
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/free-business-banking",
      function () {
        return require("private-next-pages/free-business-banking.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/free-business-banking"])
      });
    }
  